import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
//import productos from "./data";

import productosBase from "./data";
import { mergeProductos, agregarSoloFirebase } from "./utils/updateProductos";
import { listenProductos } from "./services/firebaseProductos";
import { listenCostoEnvio } from "./services/firebaseCostoEnvio";

import "./styles.css";
import Producto from "./components/Producto";
import Buscador from "./components/Buscador";
import CategoriaSelector from "./components/CategoriaSelector";
import Carrito from "./components/Carrito";

const App = () => {
    const [cantidadProductosMostrados, setCantidadProductosMostrados] = useState(50); // Mostrar 20 productos al inicio
    const [carrito, setCarrito] = useState(() => {
      try {
        const guardado = localStorage.getItem("carritoBL");
        return guardado ? JSON.parse(guardado) : [];
      } catch {
        return [];
      }
    });
    const [categoria, setCategoria] = useState("");
    const [busqueda, setBusqueda] = useState("");
    const [orden, setOrden] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [mensajeId, setMensajeId] = useState(0);
    const mensajeTimerRef = useRef(null);
    const [carritoVisible, setCarritoVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingProductos, setLoadingProductos] = useState(true);
    const [telefono, setTelefono] = useState(null);
    const [productos, setProductos] = useState([]);
    // 31000 es el valor por defecto (hardcodeado) hasta que Firebase responda
    // con el valor real desde la colección "costoEnvio"
    const [montoMinimoEnvio, setMontoMinimoEnvio] = useState(31000);

    // Persistir el carrito en localStorage cada vez que cambia
    useEffect(() => {
      try {
        localStorage.setItem("carritoBL", JSON.stringify(carrito));
      } catch (err) {
        console.error("No se pudo guardar el carrito:", err);
      }
    }, [carrito]);

    // Si el precio de un producto cambia (ej. actualización en tiempo real desde Firebase),
    // actualizar silenciosamente el precio de ese mismo producto si ya está en el carrito.
    useEffect(() => {
      if (productos.length === 0) return;

      setCarrito(prevCarrito => {
        let huboCambios = false;
        const carritoActualizado = prevCarrito.map(item => {
          const productoActual = productos.find(p => p.uid === item.uid);
          if (productoActual && productoActual.precio !== item.precio) {
            huboCambios = true;
            return { ...item, precio: productoActual.precio };
          }
          return item;
        });
        return huboCambios ? carritoActualizado : prevCarrito;
      });
    }, [productos]);

    useEffect(() => {
      // Arranca en data.js; se va actualizando a medida que el Servidor y
      // Firebase van aportando su parte, para que cada uno construya sobre
      // lo último conocido en vez de recalcular siempre desde cero.
      let catalogoActual = productosBase;

      fetch("productos.json")
      .then(res => res.json())
      .then(data => {
        const productosAcServidor = mergeProductos(catalogoActual, data);
        const { productosActualizados, nuevosProductos } = agregarSoloFirebase(productosAcServidor, data);
        if (nuevosProductos.length > 0) {
          console.log(`📦 [Servidor] ${nuevosProductos.length} producto(s) agregados desde productos.json:`, nuevosProductos);
        }
        catalogoActual = productosActualizados;
        setProductos(productosActualizados);
      })
      .catch(err => console.error("Error al cargar productos.json:", err))
      .finally(() => setLoadingProductos(false));
      const unsubscribe = listenProductos((productosFirebase) => {
        const productosActualizados = mergeProductos(catalogoActual, productosFirebase);
        const resultado = agregarSoloFirebase(productosActualizados, productosFirebase);
        if (resultado.nuevosProductos.length > 0) {
          console.log(`🔥 [Firebase] ${resultado.nuevosProductos.length} producto(s) agregados desde el listener en vivo:`, resultado.nuevosProductos);
        }
        catalogoActual = resultado.productosActualizados;
        setProductos(resultado.productosActualizados);
      });

  
      return () => unsubscribe();
    }, []);  

    // Escuchar el monto mínimo de envío gratis desde Firebase.
    // Si Firebase no responde o el campo no existe, se queda con el
    // valor por defecto (31000) que ya está seteado en el useState.
    useEffect(() => {
      const unsubscribe = listenCostoEnvio((datos) => {
        if (typeof datos.montoMinimo === "number") {
          setMontoMinimoEnvio(datos.montoMinimo);
        }
      });

      return () => unsubscribe();
    }, []);
      
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        let valor = params.get("linea"); // lee ?id=123
        
        const lista = ['5491154629882', '5491150640675', '5491160069796', '5491127949726', '5491135576005'];
        valor = lista.includes(valor) ? valor : '5491154629882';

        setTelefono(valor);
    }, [])

    useEffect(() => {
        // 24 horas en milisegundos
        const tiempo = 24 * 60 * 60 * 1000;
        // const tiempo = 1 * 60 * 1000;
    
        const timer = setTimeout(() => {
          window.location.reload(); // refresca la página
        }, tiempo);
    
        return () => clearTimeout(timer); // limpia el timer si el componente se desmonta
      }, []);
    

    // Limpiar el timer del mensaje si el componente se desmonta
    useEffect(() => {
      return () => {
        if (mensajeTimerRef.current) clearTimeout(mensajeTimerRef.current);
      };
    }, []);

    const agregarAlCarrito = (producto, cantidad) => {
      // Buscar si el producto ya está en el carrito (por uid, que es estable)
      const existeProducto = carrito.find(item => item.uid === producto.uid);
  
      if (existeProducto) {
          // Si existe, actualizar la cantidad sumándola
          setCarrito(carrito.map(item =>
              item.uid === producto.uid
                  ? { ...item, cantidad: item.cantidad + cantidad }
                  : item
          ));
      } else {
          // Si no existe, agregarlo como nuevo
          setCarrito([...carrito, { ...producto, cantidad }]);
      }
  
      // Mostrar mensaje con la cantidad agregada
      setMensaje(`✅ ${cantidad} x ${producto.nombre} agregado al carrito`);
      setMensajeId(id => id + 1);
      
      // Cancelar el timer anterior (si había uno) para que siempre dure 3s
      // desde el último producto agregado, no desde el primero
      if (mensajeTimerRef.current) clearTimeout(mensajeTimerRef.current);
      mensajeTimerRef.current = setTimeout(() => setMensaje(""), 3000);
  };

  const actualizarCantidad = (uid, nuevaCantidad) => {
    if (nuevaCantidad < 1) return;

        setCarrito(carrito.map(item =>
            item.uid === uid ? { ...item, cantidad: nuevaCantidad } : item
        ));
    };

    const eliminarProducto = (uid) => {
        setCarrito(carrito.filter(item => item.uid !== uid));
    };

    const vaciarCarrito = () => {
        if (window.confirm("¿Vaciar el carrito? Se van a eliminar todos los productos agregados.")) {
            setCarrito([]);
        }
    };

    const calcularTotal = () => {
        return carrito.reduce((total, item) => total + item.cantidad * item.precio, 0);
    };

    const calcularTotalDescuento = () => {
        return carrito.reduce((total, item) => total + item.cantidad * (item.precio * 0.9), 0);
    };

    // Formatear los precios correctamente
    const formatoPrecio = (precio) => {
        return new Intl.NumberFormat("es-ES", {
            minimumFractionDigits: 2,
            useGrouping: true
        }).format(Number(precio));
        };

    const productosFiltrados = productos
        .filter(prod =>
            (categoria ? prod.categoria === categoria : true) &&
            (busqueda ? prod.nombre.toLowerCase().includes(busqueda) : true)
        )
        .sort((a, b) => {
            switch (orden) {
                case "precio-asc":
                    return a.precio - b.precio;
                case "precio-desc":
                    return b.precio - a.precio;
                case "nombre-asc":
                    return a.nombre.localeCompare(b.nombre);
                case "nombre-desc":
                    return b.nombre.localeCompare(a.nombre);
                default:
                    return 0; // sin orden: se respeta el orden original
            }
        });
  
    const mostrarMasProductos = () => {
      setCantidadProductosMostrados(prev => prev + 50); // Incrementar en 50 productos
    };


    const enviarPedidoWhatsApp = async () => {
        try {
          setLoading(true); // 👈 activar estado de carga
    
          const payload = { productos: carrito };
          const res = await axios.post(
            "https://bienlimpitoymas-mp-nodejs.herokuapp.com/api/AddDRAFT",
            payload
          );
          const nroPedidoGenerado = res.data.nroPedido;
          // armar mensaje
          const mensajePedido = carrito
            .map(
              (item) =>
                `🛒 ${item.cantidad} x ${item.nombre} - $${item.cantidad * item.precio}`
            )
            .join("\n");
    
          const total = `\n💰 Total: $${carrito.reduce(
            (acc, item) => acc + item.cantidad * item.precio,
            0
          )}`;
    
          const mensajeFinal = encodeURIComponent(
            `¡Hola! Quiero hacer un pedido borrador ${nroPedidoGenerado}:\n\n${mensajePedido}\n${total}`
          );
    
          // usar location.href para Safari iPhone
          window.location.href = `https://wa.me/${telefono}?text=${mensajeFinal}`;
        } catch (err) {
          console.error("Error:", err.message);
        } finally {
          setLoading(false); // 👈 desactivar estado de carga
        }
      };

    return (
        <div>
            <header className="header">
                <img src={"logo.webp"} alt="Logo de limpieza" className="logo" />
                <div className="carrito-icono" onClick={() => setCarritoVisible(!carritoVisible)}>
                    {carrito.length > 0 ? "🛒" : "🛍️"}
                    {carrito.length > 0 && (
                        <span className="carrito-badge">{carrito.reduce((total, item) => total + item.cantidad, 0)}</span>
                    )}
                </div>
            </header>
            <div className="intro">
              <div className="intro-content">
                <p><span className="intro-icon" aria-hidden="true">🧼</span>Encontrá los mejores productos de limpieza aquí</p>
                <p><span className="intro-icon" aria-hidden="true">📍</span>Entregamos en Capital Federal y Zona Norte</p>
                <p className="intro-envio"><span className="intro-icon" aria-hidden="true">🚚</span>Envío GRATIS en compras mayores a ${formatoPrecio(montoMinimoEnvio)}</p>
              </div>
              <svg className="intro-wave" viewBox="0 0 1440 40" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,20 C120,40 240,0 360,20 C480,40 600,0 720,20 C840,40 960,0 1080,20 C1200,40 1320,0 1440,20 L1440,40 L0,40 Z" fill="#f5f4fa" />
              </svg>
            </div>
            <div className="filtros">
                <Buscador setBusqueda={setBusqueda} setCantidadProductosMostrados={setCantidadProductosMostrados}/>
                <CategoriaSelector setCategoria={setCategoria} setCantidadProductosMostrados={setCantidadProductosMostrados} />
                <div className="orden-selector">
                    <label htmlFor="orden">Ordenar por:</label>
                    <select id="orden" value={orden} onChange={(e) => { setOrden(e.target.value); setCantidadProductosMostrados(50); }}>
                        <option value="">Relevancia</option>
                        <option value="precio-asc">Precio: menor a mayor</option>
                        <option value="precio-desc">Precio: mayor a menor</option>
                        <option value="nombre-asc">Nombre: A-Z</option>
                        <option value="nombre-desc">Nombre: Z-A</option>
                    </select>
                </div>
            </div>

            {mensaje && <div key={mensajeId} className="notificacion">{mensaje}</div>} {/* Notificación */}
            
            {carritoVisible && (
                <Carrito
                    carrito={carrito}
                    setCarritoVisible={setCarritoVisible}
                    calcularTotal={calcularTotal}
                    calcularTotalDescuento={calcularTotalDescuento}
                    enviarPedidoWhatsApp={enviarPedidoWhatsApp}
                    actualizarCantidad={actualizarCantidad}
                    eliminarProducto={eliminarProducto}
                    vaciarCarrito={vaciarCarrito}
                    loading={loading}
                />
            )}

            {loadingProductos ? (
                <div className="loading-productos">
                    <div className="spinner"></div>
                    <p>Cargando productos...</p>
                </div>
            ) : (
                <div className={`contenedor ${productosFiltrados.length === 0 ? "sin-productos" : ""}`}>
                    {productosFiltrados.length > 0 ? (
                        productosFiltrados.slice(0, cantidadProductosMostrados).map((prod, index) => (
                            <Producto key={prod.uid} setModalVisibleAPP={setModalVisible} prod={prod} agregarAlCarrito={agregarAlCarrito} montoMinimoEnvio={montoMinimoEnvio} prioridad={index < 10} />
                        ))
                    ) : (
                        <p className="mensaje-no-productos">No hay productos para la búsqueda realizada.</p>
                    )}
                    {cantidadProductosMostrados < productosFiltrados.length && (
                    <button className="boton-ver-mas" onClick={mostrarMasProductos}>
                        {productosFiltrados.length - cantidadProductosMostrados > 50
                            ? `Ver 50 productos más (quedan ${productosFiltrados.length - cantidadProductosMostrados})`
                            : `Ver los ${productosFiltrados.length - cantidadProductosMostrados} productos restantes`}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginLeft: "6px", verticalAlign: "-2px"}}>
                            <path d="M6 9l6 6 6-6" />
                        </svg>
                    </button>
                    )}
                </div>
            )}

            {carrito.length > 0 && !carritoVisible && !modalVisible && !mensaje && (
                <div className="modal-carrito">
                    <div className="modal-carrito-precios">
                        <span className="modal-carrito-lista">Lista: ${formatoPrecio(calcularTotal())}</span>
                        <span className="modal-carrito-transferencia">${formatoPrecio(calcularTotalDescuento())} transferencia</span>
                    </div>
                    <button onClick={() => setCarritoVisible(true)}>Revisar pedido</button>
                </div>
            )}
            {/* <footer className="footer">
              <p>© 2025 Tienda de Limpieza - Todos los derechos reservados</p>
            </footer> */}
        </div>
    );
};

export default App;